/**
 * Filter reviews for offline caching
 * Returns:
 * - Most recent 10 draft/in-progress reviews (for user to continue working)
 * - Most recent 3 submitted/completed reviews per property (for sharing pre-fill)
 */
export function filterReviewsForCaching(reviews: any[]): any[] {
  // Get draft/in_progress reviews (for active work)
  const drafts = reviews
    .filter(r => r.status === 'draft' || r.status === 'in_progress')
    .sort((a, b) => {
      const aDate = a.createdAt instanceof Date ? a.createdAt : new Date(a.createdAt || a.startedAt || 0);
      const bDate = b.createdAt instanceof Date ? b.createdAt : new Date(b.createdAt || b.startedAt || 0);
      return bDate.getTime() - aDate.getTime();
    })
    .slice(0, 10); // Top 10 active reviews

  // Get submitted/completed reviews grouped by property (for sharing)
  const finishedByProperty = new Map<number, any[]>();
  reviews
    .filter(r => r.status === 'submitted' || r.status === 'completed')
    .forEach(r => {
      const propertyId = r.propertyId || r.property?.id;
      if (!propertyId) return;

      if (!finishedByProperty.has(propertyId)) {
        finishedByProperty.set(propertyId, []);
      }
      finishedByProperty.get(propertyId)!.push(r);
    });

  // Take top 3 submitted/completed reviews per property (most recently finished)
  const recentFinished: any[] = [];
  finishedByProperty.forEach((propertyReviews) => {
    propertyReviews
      .sort((a, b) => {
        const aDate = new Date(a.completedAt || a.submittedAt || 0);
        const bDate = new Date(b.completedAt || b.submittedAt || 0);
        return bDate.getTime() - aDate.getTime();
      })
      .slice(0, 3) // Top 3 per property (increased from 2)
      .forEach(r => recentFinished.push(r));
  });

  return [...drafts, ...recentFinished];
}
